import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=1477d3e5&scoped=true"
import script from "./stocks.vue?vue&type=script&lang=js"
export * from "./stocks.vue?vue&type=script&lang=js"
import style0 from "./stocks.vue?vue&type=style&index=0&id=1477d3e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477d3e5",
  null
  
)

export default component.exports